import React from "react";
import { Typography } from "@mui/material";
import WidgetFrame, { WidgetButton } from "./WidgetFrame";
import DefinitionList from "./DefinitionList";
import { FORM_ERROR_KEY } from "./kinds";
import { useWidgetMsg } from "../../../hooks/widget/useWidgetMsg";

/**
 * `confirmation` (spec-widget-mcp 05 Step 8): what is about to happen, then two buttons. BOTH are
 * submissions — Confirm posts `{ confirmed: true }`, Cancel posts `{ confirmed: false }`; Cancel is
 * never a dismiss (the model must learn the customer declined). The optional `warning` is
 * `role="alert"` (AC-16). Collapsed it reads Confirmed / Declined (`model/submission.js`).
 */
export default function ConfirmationWidget({ envelope, idPrefix, submitter }) {
	const { msg } = useWidgetMsg();
	const p = envelope.payload || {};
	const disabled = submitter.status === "sending" || !submitter.canSubmit;
	const error = submitter.rejection?.fields?.confirmed || submitter.rejection?.fields?.[FORM_ERROR_KEY] || null;
	const titleId = `${idPrefix}-title`;

	return (
		<WidgetFrame
			kind="confirmation"
			title={p.title}
			titleId={titleId}
			footer={(
				<>
					<WidgetButton data-testid="widget-cancel" variant="ghost" onClick={() => submitter.submit({ confirmed: false })} disabled={disabled}>
						{p.cancelLabel || msg("widget.cancel", "Cancel")}
					</WidgetButton>
					<WidgetButton data-testid="widget-confirm" onClick={() => submitter.submit({ confirmed: true })} disabled={disabled}>
						{p.confirmLabel || msg("widget.confirm", "Confirm")}
					</WidgetButton>
				</>
			)}
		>
			<DefinitionList items={p.summary} />
			{p.warning && (
				<Typography role="alert" sx={{ fontSize: 12, background: "var(--w-warning-bg)", color: "var(--w-warning-color)", border: "1px solid var(--w-border)", borderRadius: "8px", px: 1.25, py: 0.75 }}>
					{p.warning}
				</Typography>
			)}
			{error && <Typography sx={{ fontSize: 11.5, color: "var(--w-error)" }}>{error}</Typography>}
		</WidgetFrame>
	);
}
